import { useRequest } from "../../../app/hooks/useRequest";
import { getProgramTypesRequest } from "../ProgramTypeRequests";

export const useGetProgramTypes = () => useRequest(getProgramTypesRequest);
